import React, { createRef, useEffect, useMemo, useState } from "react";

import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { getDateTime, SessionKeys } from "../../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

import {
    getCrsReportManagers,
    getCrsReportManagersClear,
    getCrsReportOffices,
    getCrsReportOfficesClear,
    getCrsReportRea,
    getCrsReportReaClear,
    getCrsReportStats,
    getCrsReportStatsClear,
    getCrsReportTrend,
    getCrsReportTrendClear,
    getCrsReportTrendOfSingle,
    getCrsReportTrendOfSingleClear
} from "../../../redux/reports/actions";
import _, { assign } from "lodash";
import ProgressReportTableComponent from "../progressReport/ProgressReportTableComponent";
import RealEstateAgentsReportSection from "./RealEstateAgentsReportSection";
import Loader from "../../Loader/Loader";
import PiechartProgressReport from "../New Progress Report/PiechartProgressReport";
import {
    getAnyTotalReportClear,
    getProfileCompletionReport,
    getProfileCompletionReportClear,
} from "../../../redux/reports/actions";

import CONFIG from "../../../utils/config";
import PieChartComponent from "../ReportsComponents/PieChartComponent";
import ReportTableSectionComp from "../ReportsComponents/ReportTableSectionComp";
import { useLocation, useNavigate } from "react-router-dom";
import ManagerReportSec from "../ReportsComponents/ManagerReportSec";
import OfficeSection from "../ReportsComponents/OfficeSection";
import CompletionTrendGraph from "../ReportsComponents/CompletionTrendGraph";
import { Spinner } from "react-bootstrap";
import ManagerReportCrs from '../New Progress Report/ManagerReportCrs';
import OfficesReportSection from "../New Progress Report/OfficesReportSection";

import CompletionTrendGraphNew from "../ReportsComponents/CompletionTrendGraphNew";
import DonutChart from "../../Layouts/Graphs/DonutChart";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import ChooseOfficePeople from "../../reportFilter/ChooseOfficePeople";
import ChooseProvider from "../../reportFilter/ChooseProvider";
import ChooseCourse from "../../reportFilter/ChooseCourse";
import ChooseManager from "../../reportFilter/ChooseManager";
import ChooseREA from "../../reportFilter/ChooseREA";
import { getTeamMatesResClear } from "../../../redux/assignCourse/actions";
import TrendChart from "../../../utils/TrendChart";
import TrendChartSingle from "../../../utils/TrendChartSingle";
import ReportGraphComponent from "../layout/ReportGraphComponent";
import ProgressReportTableComponentForAgentDetail from "../progressReport/ProgressReportTableComponentForAgentDetail";
import * as XLSX from "xlsx";
import StaticUtils from "../../../utils/StaticUtils";
import REACardAreaSection from "../layout/REACardAreaSection";
import NotFoundImage from "../../NewDesign/NotFound/NotFoundImage";

const ComplianceReportSectionDetail = (props) => {

    const {
        isMobile
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const isCompliance = params.get("isCompliance");
    const idFrom = params.get("id");
    const from = params.get("from");
    const isVideos = params.get("isVideos");

    const crsOfficesRes = useSelector((state) => state.report?.crsReportOffices);

    const overAllSummaryCrsRes = useSelector(
        (state) => state.report.overallSummaryCrsData
    );
    const [overSummaryCrsData, setOverSummaryCrsData] = useState([]);
    const overAllDataRes = useSelector((state) => state.report.overallData);
    const overAllSummaryGraphRes = useSelector(
        (state) => state.report.overallSummaryCrsGraph
    );
    const [reaList, setReaList] = useState([])
    const [overCrsGraphData, setOverCrsGraphData] = useState([]);
    const [crsCompltTrendData, setCrsCompltTrendData] = useState([]);
    const [overAllData, setOverAllData] = useState([]);
    const [overAllOfficesData, setOverAllOfficesData] = useState([]);
    const [overAllManagersData, setOverAllManagersData] = useState([]);
    const [overAllLearningPoints, setOverAllLearningPoints] = useState([]);
    const [overAllLearningHours, setOverAllLearningHours] = useState([]);
    const [OverAllStatsData, setOverAllStatsData] = useState([]);
    const [isView, setIsView] = useState("table");
    const [type, setType] = useState("pie");
    const [canShow, setCanShow] = useState(false);
    const [isLoaded, setIsLoaded] = useState(true);
    const [limitStatus, setLimitStatus] = useState("")
    const [loadSpin, setLoadSpin] = useState(true)
    const [totalRea, setTotalRea] = useState([])
    const [isLoading, setIsLoading] = useState(true);
    const [imgLoader, setImgLoader] = useState(true);
    const [crsCompltTrendValues, setCrsCompltTrendValues] = useState([]);
    const [crsCompltTrendValuesOfSingle, setCrsCompltTrendValuesOfSingle] = useState([]);
    const [trendFilterCourses, setTrendFilterCourses] = useState([]);
    const [trendFilterCoursesOfSingle, setTrendFilterCoursesOfSingle] = useState([]);
    const [statusFilterData] = useState([
        "Completed",
        "Inprogress",
        "OverDue",
        "Yet to start",
    ]);
    const crsTableRes = useSelector((state) => state.report?.lpTable);
    const crsReaRes = useSelector((state) => state.report?.crsReportRea);
    const crsTrendRes = useSelector((state) => state.report?.crsReportTrend);
    const crsReportTrendOfSingleRes = useSelector((state) => state.report?.crsReportTrendOfSingle);
    const crsStatsRes = useSelector((state) => state.report?.crsReportStats);
    const [profileReports, setProfileReports] = useState(null);
    const [profileReportsFilter, setProfileReportsFilter] = useState([]);
    const [realEstateAgent, setRealEstateAgent] = useState([]);
    const [filterYearData, setFilterYearData] = useState([])
    const [filterYearDataOfSingle, setFilterYearDataOfSingle] = useState([])
    const [legendOfSingle, setLegendOfSingle] = useState([])
    const [seriesOfSingle, setSeriesOfSingle] = useState([])
    const [legendOfAll, setLegendOfAll] = useState([])
    const [seriesOfAll, setSeriesOfAll] = useState([])
    // const [dateRange, setDateRange] = useState({ "start": "", "end": "" })
    const [totalManagers, setTotalManagers] = useState([])
    const profileReportRes = useSelector((state) => state.report.profileReport);
    const d = new Date();
    let year = d.getFullYear();
    const [trendYear, setTrendYear] = useState(year)
    const anyTotalReportRes = useSelector(
        (state) => state.report?.anyTotalReport
    );
    const crsCompletionTrendRes = useSelector(
        (state) => state.report.crsCompletionTrend
    );
    const [currentPage, setCurrentPage] = useState(1);
    const [limitData, setLimitData] = useState();
    const [totalRecord, setTotalRecord] = useState(0);
    const [legends, setLegends] = useState([]);
    const [series, setSeries] = useState([]);
    let PageSize = 20;
    const [counter, setCounter] = useState(1);
    const FILTER_BY = [
        { id: 0, value: "Select" },
        { id: 1, value: "Learning Points" },
        { id: 2, value: "Progress" },
        { id: 3, value: "Learning Hours" },
    ];
    const [filterBy, setFilterBy] = useState(FILTER_BY[0].value);
    const [actualCoursesList, setActualCoursesList] = useState([]);
    const [loaderChart, setLoaderChart] = useState(true)
    const [trendLoaderChart, setTrendLoaderChart] = useState(false)
    const [coursesList, setCoursesList] = useState([]);
    const [increment, setIncrement] = useState(1);
    const rea_ids = []
    const manager_ids = []
    const office_ids = []
    const courseList = []
    const providerList = []
    const role=[];
    const status=[];
    const assignmentFrom=[];
    let brokerages= [];
    let user_id =1;
    let dateRange= {};
    const [selectedOfficeList, setSelectedOfficeList] = useState(
        []
    );
    const [selectedRea] = useState(
        location?.state?.selectedTeamMatesList
    );
    const [pageNum, setPageNum] = useState(0)
    const [pageSize, setPageSize] = useState(50);
    const [progressSort, setProgressSort] = useState("asc");
    const [searchInput, setSearchInput] = useState('')
    const [selectedCrsList] = useState(
        location?.state?.selectedCourseList)
    const [selectedProviderList, setSelectedProviderList] = useState([])
    const [selectedCourseList, setSelectedCourseList] = useState([])
    const [selectedManagerCoachList, setSelectedManagerCoachList] = useState([])
    const [selectedTeamMatesList, setSelectedTeamMatesList] = useState([])
    const [selectedStatus, setSelectedStatus] = useState(["completed", "in-progress", "overdue", "not-started"])
    const [officeDetail, setOfficeDetail] = useState({});
    const currentObjData = useState(
        location?.state?.currentReportObj)

    const userDetailRes = useSelector(state => state.user.userBroker)
    const userDetailIframe = useSelector(state => state.user.userDetailIframe)
    const [userDetails, setUserDetails] = useState({});

    const [check, setCheck] = useState(isCompliance === "0" ? false : true)
    const [checkCompleted, setCheckCompleted] = useState(true)
    const [checkInProgress, setCheckInProgress] = useState(true)
    const [checkOverdue, setCheckOverdue] = useState(true)
    const [checkYetToStart, setCheckYetToStart] = useState(true)
    const [counterForMng, setCounterForMng] = useState(1);
    const crsManagersRes = useSelector((state) => state.report?.crsReportManagers);

    // new designchanges 1-May-23
    const [isExpand, setIsExpand] = useState(false);

    useEffect(() => {
        console.log('dateRange: ', dateRange)
    }, [dateRange])

    useEffect(() => {
        console.log('isCompliance: ', isCompliance);
        if (isCompliance === "0") {
            setCheck(false)
        }
    }, [isCompliance])

    useEffect(() => {
        // console.log('userDetailRes: ', userDetailRes)
        if (isMobile) {
            if (!_.isEmpty(userDetailIframe?.payload?.payload)) {
                setUserDetails(userDetailIframe?.payload?.payload)
            }
        } else {
            if (!_.isEmpty(userDetailRes?.payload?.payload)) {
                setUserDetails(userDetailRes?.payload?.payload)
            }
        }
    }, [userDetailRes, userDetailIframe, isMobile])
    useEffect(() => {
        selectedOfficeList.forEach(function (obj) {
            office_ids.push(obj.office_id);
        })
        selectedTeamMatesList.forEach(function (obj) {
            rea_ids.push(obj.user_id);
        })
        selectedManagerCoachList.forEach(function (obj) {
            manager_ids.push(obj.id);
        })
        selectedProviderList.forEach(function (obj) {
            providerList.push(obj.p_id)
        })
        selectedCourseList.forEach(function (obj) {
            if (obj.source === "xsel") {
                courseList.push(obj.course_code)
            } else {
                courseList.push(obj.course_id)
            }
        })
    })

    useEffect(() => {
        setSelectedManagerCoachList([])
    }, [idFrom])

    // COUNT INCREAMENT
    function setCount(counter, setCounter) {
        return setCounter(counter + 1);
    }

    function setCountForManager(counter, setCounterForMng) {
        return setCounterForMng(counter + 1);
    }

    useEffect(() => {
        setPageNum(0)
        setProgressSort('asc');
        setSearchInput('')
        hitAllFilterApi(1, "", "asc");
        // setFilterBy(FILTER_BY[0].value);
    }, [dispatch]);
    useEffect(() => {
        hitReaListApi();
    }, [counter])

    useEffect(() => {
        hitManagerListApi();
    }, [counterForMng])

    useEffect(() => {
        // hitTrendingApi();
        // setFilterBy(FILTER_BY[0].value);
    }, [trendYear]);
  

    const getStatusArr = () => {
        let statusArr = [];
        if (checkCompleted) {
            statusArr.push('completed');
        }
        if (checkInProgress) {
            statusArr.push('in-progress');
        }
        if (checkOverdue) {
            statusArr.push('overdue');
        }
        if (checkYetToStart) {
            statusArr.push('not-started');
        }
        setSelectedStatus(statusArr)
        return statusArr;
    }

    const hitReaListApi = (callAPI = true) => {
        if(callAPI) { getAppliedFilters();
        }
        let statusArr = getStatusArr();
        dispatch(getCrsReportRea({
            module: 'getCourseReportRea',
            postData: {
                token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                rea_ids: rea_ids,
                limit: counter,
                office_ids: [idFrom],
                entity_id: courseList,
                compliance: check ? 1 : 0,
                manager_ids: manager_ids,
                date_range: dateRange?.start || dateRange?.end ?  dateRange : {},
                status: _.isEmpty(status)
            ? ["completed", "in-progress", "overdue", "not-started"]
            : status,
          role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
          assigner_role: _.isEmpty(assignmentFrom) ? ["api","self","manager","broker_admin"] : assignmentFrom,
                is_videos: JSON.parse(isVideos),
                user_status: user_id,
                brokerage: brokerages,
                provider_ids: providerList,
            }
        }))
    }

    const hitManagerListApi = (callAPI = true) => {
        if(callAPI) {
        getAppliedFilters();
        }
        dispatch(getCrsReportManagers({
            module: 'getCourseReportManagers',
            postData: {
                token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                limit: counterForMng,
                office_ids: [idFrom],
                entity_id: courseList,
                compliance: check ? 1 : 0,
                manager_ids: manager_ids,
                rea_ids: rea_ids,
                date_range: dateRange?.start || dateRange?.end ?  dateRange : {},
                status: _.isEmpty(status)
            ? ["completed", "in-progress", "overdue", "not-started"]
            : status,
          role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
          assigner_role: _.isEmpty(assignmentFrom) ? ["api","self","manager","broker_admin"] : assignmentFrom,
                is_videos: JSON.parse(isVideos),
                user_status: user_id,
                brokerage: brokerages,
                provider_ids: providerList,
            }
        }))
    }

    const fetchCrsTableReport = (userStatus, page = 0, searchTerm = "", sort = "") => {
        getAppliedFilters();
        dispatch(
          getProfileCompletionReport({
            module: "getCourseProgressReport",
            postData: {
                token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                limit: counter,
                rea_ids: rea_ids,
                entity_id: courseList,  //course_codes
                office_ids: [idFrom],
                provider_ids: providerList,
                compliance: check ? 1 : 0,
                manager_ids: manager_ids,
                date_range: dateRange?.start || dateRange?.end ?  dateRange : {},
                status: _.isEmpty(status)
        ? ["completed", "in-progress", "overdue", "not-started"]
        : status,
      role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
      assigner_role: _.isEmpty(assignmentFrom) ? ["api","self","manager","broker_admin"] : assignmentFrom,
                is_videos: JSON.parse(isVideos),
                user_status: user_id,
                brokerage: brokerages,
                page: page ? page : pageNum ? pageNum : 1,
                page_size:pageSize,
                sortBy: sort ? sort : progressSort ? progressSort : 'asc',
                search: searchTerm ? searchTerm : searchInput ? searchInput : "",
            },
          })
        );
      }

    const hitOfficeDetailApi = (callAPI = true) => {
        if(callAPI) {
        getAppliedFilters();
        }
        dispatch(getCrsReportOffices({
            module: 'getCourseReportOffices',
            postData: {
                token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                office_ids: [idFrom],
                rea_ids: rea_ids,
                limit: counter,
                entity_id: courseList,
                provider_ids: providerList,
                compliance: check ? 1 : 0,
                manager_ids: manager_ids,
                date_range: dateRange?.start || dateRange?.end ?  dateRange : {},
                status: _.isEmpty(status)
            ? ["completed", "in-progress", "overdue", "not-started"]
            : status,
          role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
          assigner_role: _.isEmpty(assignmentFrom) ? ["api","self","manager","broker_admin"] : assignmentFrom,
                is_videos: JSON.parse(isVideos),
                user_status: user_id,
                brokerage: brokerages
            }
        }))
    }

    const hitTrendingApi = () => {
        setTrendLoaderChart(true);
        let statusArr = getStatusArr();
        dispatch(getCrsReportTrend({
            module: 'getCourseReportTrend',
            postData: {
                token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                office_ids: [idFrom],
                rea_ids: rea_ids,
                entity_id: courseList,
                compliance: check ? 1 : 0,
                year: _.toNumber(trendYear),
                manager_ids: manager_ids,
                date_range: dateRange?.start || dateRange?.end ?  dateRange : {},
                status: _.isEmpty(status)
            ? ["completed", "in-progress", "overdue", "not-started"]
            : status,
          role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
          assigner_role: _.isEmpty(assignmentFrom) ? ["api","self","manager","broker_admin"] : assignmentFrom,
                is_videos: JSON.parse(isVideos),
                user_status: user_id,
                brokerage: brokerages
            }
        }))
    }

    const getAppliedFilters = () => {
        let selectedFilters = JSON.parse(localStorage.getItem("SELECTED_FILTER"));
        console.log("selected_fil---",selectedFilters?.selectedFilters);
        let filtersApplied = selectedFilters?.selectedFilters;
        filtersApplied.selectedTeamMatesList.forEach(function (obj) {
          rea_ids.push(obj.user_id);
        });
        filtersApplied.selectedOfficeList.forEach(function (obj) {
            office_ids.push(obj.office_id);
          });
        filtersApplied.selectedManagerCoachList.forEach(function (obj) {
          manager_ids.push(obj.id);
        });
        filtersApplied.selectedProviderList.forEach(function (obj) {
          providerList.push(obj.p_id);
        });
        filtersApplied.selectedCourseList.forEach(function (obj) {
          if (obj.source === "xsel") {
            courseList.push(obj.course_code);
          } else {
            courseList.push(obj.course_id);
          }
        });
        if(filtersApplied?.dateRange) {
            dateRange.start = filtersApplied?.dateRange?.start;
            dateRange.end = filtersApplied?.dateRange?.end;
        }
        filtersApplied.selectedStatus.forEach(function (obj) {
          status.push(obj);
        });
        filtersApplied.selectedAssignment.forEach(function (obj) {
            assignmentFrom.push(obj);
          });
        filtersApplied.selectedRole.forEach(function (obj) {
          role.push(obj);
        });
        filtersApplied?.selectedBrokerageList?.forEach(function (obj) {
            brokerages.push(obj);
          });
        user_id=[];
        if (_.isArray(filtersApplied.selectedAgentStatus)) {
          if (filtersApplied.selectedAgentStatus.includes(3) ||
            (filtersApplied.selectedAgentStatus.includes(1) && filtersApplied.selectedAgentStatus.includes(2))
          ) {
            user_id = 3
          } else if (filtersApplied.selectedAgentStatus.includes(1)) {
            user_id = 1
          } else if (filtersApplied.selectedAgentStatus.includes(2)) {
            user_id = 2
          }
        }
    }
    const hitAllFilterApi = ( page = 0, searchTerm = "", sort = "") => {
        // ["","in-progress","not-started"],

        getAppliedFilters();
        let statusArr = getStatusArr();
        dispatch(
            getProfileCompletionReport({
                module: "getCourseProgressReport",
                postData: {
                    token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                    limit: counter,
                    rea_ids: rea_ids,
                    entity_id: courseList,  //course_codes
                    office_ids: [idFrom],
                    provider_ids: providerList,
                    compliance: check ? 1 : 0,
                    manager_ids: manager_ids,
                    date_range: dateRange?.start || dateRange?.end ?  dateRange : {},
                    status: _.isEmpty(status)
            ? ["completed", "in-progress", "overdue", "not-started"]
            : status,
          role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
          assigner_role: _.isEmpty(assignmentFrom) ? ["api","self","manager","broker_admin"] : assignmentFrom,
                    is_videos: JSON.parse(isVideos),
                    user_status: user_id,
                    brokerage: brokerages,
                    page: page ? page : pageNum ? pageNum : 1,
                    page_size: pageSize,
                    sortBy: sort ? sort : progressSort ? progressSort : 'asc',
                    search: searchTerm ? searchTerm : searchInput ? searchInput : "",
                },
            })
        );

        hitReaListApi(false);
        hitManagerListApi(false);

        hitOfficeDetailApi(false);

        // hitTrendingApi();

        // getSingleCompletionTrend(courseList);

        dispatch(getCrsReportStats({
            module: 'getCourseReportStats',
            postData: {
                token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                office_ids: [idFrom],
                rea_ids: rea_ids,
                entity_id: courseList,
                compliance: check ? 1 : 0,
                manager_ids: manager_ids,
                date_range: dateRange?.start || dateRange?.end ?  dateRange : {},
                status: _.isEmpty(status)
            ? ["completed", "in-progress", "overdue", "not-started"]
            : status,
          role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
          assigner_role: _.isEmpty(assignmentFrom) ? ["api","self","manager","broker_admin"] : assignmentFrom,
                is_videos: JSON.parse(isVideos),
                user_status: user_id,
                brokerage: brokerages,
                provider_ids: providerList,

            }
        }))

    }
    const getSingleCompletionTrend = (courseList) => {
        setIsLoading(true)
        setLoaderChart(true)
        let statusArr = getStatusArr();
        dispatch(getCrsReportTrendOfSingle({
            module: 'getCourseReportTrend',
            postData: {
                token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                office_ids: office_ids,
                entity_id: courseList,
                rea_ids: rea_ids,
                compliance: check ? 1 : 0,
                year: _.toNumber(trendYear),
                manager_ids: manager_ids,
                date_range: dateRange?.start || dateRange?.end ?  dateRange : {},
                status: _.isEmpty(status)
            ? ["completed", "in-progress", "overdue", "not-started"]
            : status,
          role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
          assigner_role: _.isEmpty(assignmentFrom) ? ["api","self","manager","broker_admin"] : assignmentFrom,
                is_videos: JSON.parse(isVideos),
                user_status: user_id,
                brokerage: brokerages

            }
        }))
    }

    useEffect(() => {
        if (!_.isEmpty(crsOfficesRes)) {

            if (crsOfficesRes?.status === "success") {
                let allData = (crsOfficesRes?.payload?.payload?.offices);

                if (allData?.length > 0)
                    setOfficeDetail(allData[0])

                dispatch(getCrsReportOfficesClear())
            }
        }
    }, [crsOfficesRes])

    const searchTable = (searchVal) => {
        let list = _.cloneDeep(profileReportsFilter);
        if (searchVal === "") { setProfileReports(list); return; }

        let filterBySearch = [];
        for (const item of list) {
            if (item?.first_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
                item?.last_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
                item?.full_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
                item?.course_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
                item?.user_manager_name?.toLowerCase().includes(searchVal.toLowerCase())) {
                filterBySearch.push(item)
            }
        }
        console.log('filterBySearch: ', filterBySearch);

        setProfileReports(filterBySearch);
    }

    useEffect(() => {
        if (!_.isEmpty(profileReportRes)) {
            let legends = [];
            let series = [];
            if (profileReportRes?.status === "success") {
                setIsLoading(false);
                const reportData = profileReportRes?.payload?.payload;
                setProfileReports(reportData);
                setProfileReportsFilter(reportData);
                if (statusFilterData.includes("Completed")) {
                    let completedCount = reportData?.user_data?.filter((data) => data.profile_status === "Completed").length
                    series.push(
                        reportData?.user_data?.filter((data) => data.profile_status === "Completed").length
                    );
                    legends.push(`Completed (${completedCount})`);
                }
                if (statusFilterData.includes("Inprogress")) {
                    let inprogressCount = reportData?.user_data?.filter((data) => data.profile_status === "Inprogress").length
                    series.push(
                        reportData?.user_data?.filter((data) => data.profile_status === "Inprogress").length
                    );
                    legends.push(`In Progress(${inprogressCount})`);
                }
                if (statusFilterData.includes("OverDue")) {
                    let overdueCount = reportData?.user_data?.filter((data) => data.profile_status === "OverDue").length
                    series.push(
                        reportData?.user_data?.filter((data) => data.profile_status === "OverDue").length
                    );
                    legends.push(`Overdue(${overdueCount})`);
                }
                if (statusFilterData.includes("Yet to start")) {
                    let notStartedCount = reportData?.user_data?.filter((data) => data.profile_status === "Yet to start").length
                    series.push(
                        reportData?.user_data?.filter((data) => data.profile_status === "Yet to start").length
                    );
                    // legends.push(`Yet to start (${notStartedCount})`);
                    legends.push(`Yet to start (${notStartedCount})`);
                }
                setLegends(legends);
                setSeries(series);
                setCurrentPage(1);
            } else {
                setProfileReports([]);
                setCanShow(false);
                setIsLoading(false);
            }
            dispatch(getProfileCompletionReportClear());
        }
    }, [profileReportRes]);

    useEffect(() => {
        if (!_.isEmpty(anyTotalReportRes)) {
            if (anyTotalReportRes.status === "success") {
                setTotalRecord(anyTotalReportRes.payload.payload.length);
            }
            return () => {
                dispatch(getAnyTotalReportClear());
            };
        }
    }, [anyTotalReportRes]);


    useEffect(() => {
        dispatch(
            getCrsReportStatsClear());
    }, [dispatch])

    useEffect(() => {
        setCounter(1)
        setRealEstateAgent([])
        return (() => {
            dispatch(getCrsReportReaClear())
        })
    }, [])
    //LP Rea
    useEffect(() => {
        if (!_.isEmpty(crsReaRes)) {
            setLoadSpin(false)
            if (crsReaRes?.status === "success") {
                let allData = [];
                allData = sortByAlphabetical(crsReaRes?.payload?.payload?.real_estate_agents);
                let realEstateAgents = crsReaRes?.payload?.payload?.real_estate_agents;
                setTotalRea(crsReaRes?.payload?.payload)
                let temparr = _.cloneDeep(realEstateAgent)
                if (counter === 1) {
                    temparr = []
                }
                setReaList([...temparr, ...allData])
                setLimitStatus(crsReaRes?.payload?.payload?.real_estate_agents)
                setRealEstateAgent([...temparr, ...allData]);
                setActualCoursesList([...temparr, ...allData]);
                dispatch(getCrsReportReaClear())
            } else {
                setRealEstateAgent([]);
                setActualCoursesList([]);
            }
        }
    }, [crsReaRes])

    useEffect(() => {
        return (() => {
            dispatch(getCrsReportTrendClear())
        })
    }, [])
    //Compliance Completion trend
    useEffect(() => {
        if (!_.isEmpty(crsTrendRes)) {
            setImgLoader(false);
            setLoaderChart(false)
            setTrendLoaderChart(false)
            if (crsTrendRes?.status === "success") {
                let allData = []
                allData = crsTrendRes?.payload?.payload?.completion_trend;
                let trendData = Object.entries(allData) //Object.values(allData)
                let tempArrTrend = [['', 'Percentage']]

                for (const [key, value] of trendData) {
                    tempArrTrend.push([key, value])
                }
                setCrsCompltTrendValues(tempArrTrend)

                // setCrsCompltTrendValues(Object.values(allData));
                setFilterYearData(crsTrendRes?.payload?.payload?.year)
                setTrendFilterCourses(crsTrendRes?.payload?.payload?.courses)

                let tempArr = [];
                let tempArrSeries = [];
                let legend = crsTrendRes?.payload?.payload?.legends_data;
                tempArr.push(`Completed (${legend?.completed})`);
                tempArrSeries.push(legend?.completed)
                tempArr.push(`In Progress(${legend?.inprogress})`);
                tempArrSeries.push(legend?.inprogress)
                tempArr.push(`Overdue(${legend?.overdue})`);
                tempArrSeries.push(legend?.overdue)
                tempArr.push(`Yet to start (${legend?.notstarted})`);
                tempArrSeries.push(legend?.notstarted)
                setLegendOfAll(tempArr)
                setSeriesOfAll(tempArrSeries)

                dispatch(getCrsReportTrendClear())
            }
        }
    }, [crsTrendRes])

    useEffect(() => {
        if (!_.isEmpty(crsReportTrendOfSingleRes)) {
            setImgLoader(false);
            setIsLoading(false);
            setLoaderChart(false)
            if (crsReportTrendOfSingleRes?.status === "success") {
                let allData = []
                allData = crsReportTrendOfSingleRes?.payload?.payload?.completion_trend;
                let trendData = Object.entries(allData) //Object.values(allData)
                let tempArrTrend = [['', 'Percentage']]

                for (const [key, value] of trendData) {
                    tempArrTrend.push([key, value])
                }
                // setCrsCompltTrendValuesOfSingle(tempArrTrend)
                setCrsCompltTrendValuesOfSingle(Object.values(allData));
                setFilterYearDataOfSingle(crsReportTrendOfSingleRes?.payload?.payload?.year)

                let tempArr = [];
                let tempArrSeries = [];
                let legend = crsReportTrendOfSingleRes?.payload?.payload?.legends_data;
                tempArr.push(`Completed (${legend?.completed})`);
                tempArrSeries.push(legend?.completed)
                tempArr.push(`In Progress(${legend?.inprogress})`);
                tempArrSeries.push(legend?.inprogress)
                tempArr.push(`Overdue(${legend?.overdue})`);
                tempArrSeries.push(legend?.overdue)
                tempArr.push(`Yet to start (${legend?.notstarted})`);
                tempArrSeries.push(legend?.notstarted)

                setLegendOfSingle(tempArr)
                setSeriesOfSingle(tempArrSeries)
                dispatch(getCrsReportTrendOfSingleClear())
            }
        }
    }, [crsReportTrendOfSingleRes])

    //Compliance Stats
    useEffect(() => {
        if (!_.isEmpty(crsStatsRes)) {
            if (crsStatsRes?.status === "success") {
                setIsLoaded(false);
                let allData = crsStatsRes?.payload?.payload?.stats;
                setOverAllLearningPoints(allData)
            }
            getCrsReportStatsClear()
        }
    }, [crsStatsRes])

    const currentTableData = useMemo(() => {
        if (profileReports !== null) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            setCanShow(true);
            return profileReports?.user_data?.slice(firstPageIndex, lastPageIndex);
        }
    }, [currentPage, profileReports]);
    // let min = Math.ceil(overAllLearningPoints?.learning_mins * 60);
    // filtration
    const sortByAlphabetical = (list) => {
        return list?.sort((a, b) => b.learning_points - a.learning_points);
    };
    const sortByProgress = (list) => {
        return list?.sort(
            (a, b) =>
                _.toNumber(b.learning_percentage) - _.toNumber(a.learning_percentage)
        );
    };
    const sortByLearningHrs = (list) => {
        return list?.sort(
            (a, b) => _.toNumber(b.learning_hrs) - _.toNumber(a.learning_hrs)
        );
    };

    // useEffect(() => {
    //   if (counter > 1)
    //     sortAfterLoadMore();
    // }, [actualCoursesList])

    const sortAfterLoadMore = () => {
        if (filterBy === "Learning Points") {
            const sortedList = sortByAlphabetical(actualCoursesList);
            setRealEstateAgent(sortedList);
        } else if (filterBy === "Progress") {
            const sortedList = sortByProgress(actualCoursesList);
            setRealEstateAgent(sortedList);
        } else if (filterBy === "Learning Hours") {
            const sortedList = sortByLearningHrs(actualCoursesList);
            setRealEstateAgent(sortedList);
        } else {
            setRealEstateAgent(reaList)
        }
    };

    const ExportToExcel = () => {
        const data = _.cloneDeep(profileReports?.user_data);
        for (let item of data) {
            item.profile_status =
                item?.profile_status === "Inprogress"
                    ? "In Progress"
                    : item?.profile_status === "Yet to start" || item?.profile_status === "not-started"
                        ? "Yet to start"
                        : item?.profile_status === "OverDue"
                            ? "Overdue"
                            : "Completed";
            item.profile_progress =
                item?.profile_progress !== undefined && item?.profile_progress !== ""
                    ? item?.profile_progress + "%"
                    : "-";
            item.complete_date =
                item?.complete_date !== undefined && item?.complete_date !== ""
                    ? moment(
                        StaticUtils.getDateFromTimeStamp(item?.complete_date),
                        "MM/DD/YYYY"
                    ).format("DD MMM, YYYY")
                    : "-";
        }

        //for sequencing
        let tempArr = [];
        for (const item of data) {
            let obj = {
                "first_name": item.first_name,
                "last_name": item.last_name,
                "email": item.email,
                "user_manager_name": item.user_manager_name,
                "ofc_location": item.ofc_location,
                "office_name": item.office_name,
                "course_name": item.course_name,
                "profile_status": item.profile_status,
                "profile_progress": item.profile_progress,
                "complete_date": item.complete_date,
            }
            tempArr.push(obj)

        }


        const newThing = [];
        tempArr.map((item) => {
            newThing.push(
                _.mapKeys(item, (value, key) => {
                    switch (key) {
                        case "first_name":
                            return "First Name";
                        case "last_name":
                            return "Last Name";
                        case "email":
                            return "Email";
                        case "user_manager_name":
                            return "Reports to";
                        case "ofc_location":
                            return "Location";
                        case "course_name":
                            return JSON.parse(isVideos) ? "Video" : "Course";
                        case "profile_status":
                            return "Status";
                        case "profile_progress":
                            return "Progress %";
                        default:
                            return;
                    }
                })
            );
        });

        for (let i = 0; i < newThing.length; i++) {
            // arrayObj[i].stroke = arrayObj[i]['key1'];
            delete newThing[i].undefined;
        }

        for (let i = 0; i < data.length; i++) {
            // arrayObj[i].stroke = arrayObj[i]['key1'];
            delete data[i]._id;
        }
        // console.log('data:', data)
        // exportFromJSON({ data, fileName, exportType })

        //For mobile
        let tempObj = {
            method: isCompliance === "0" ? "LearningProgressReport" : "ComplianceReport",
            report: newThing,
            isVideos: JSON.parse(isVideos)
        }
        if (window.callbackHandler != undefined) {
            window.callbackHandler.postMessage(JSON.stringify(tempObj));
        } else if (window.webkit != undefined) {
            if (window.webkit.messageHandlers.callbackHandler != undefined) {
                window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(tempObj));
            }
        }



        const worksheet = XLSX.utils.json_to_sheet(newThing);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
        //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        let fileNameNew = check ? "ComplianceReport" : "LearningProgressReport"
        XLSX.writeFile(workbook, fileNameNew + ".xlsx");
    };

    useEffect(() => {
        if (!_.isEmpty(crsManagersRes)) {
            setLoadSpin(false)
            if (crsManagersRes?.status === "success") {
                let allData = (crsManagersRes?.payload?.payload?.managers);
                setTotalManagers(crsManagersRes?.payload?.payload)
                let temparr = _.cloneDeep(overAllManagersData)
                if (counterForMng === 1) {
                    temparr = []
                }
                setOverAllManagersData([...temparr, ...allData]);
                dispatch(getCrsReportManagersClear());
            } else {
                let temparr = _.cloneDeep(overAllManagersData)
                setOverAllManagersData(temparr);
            }
        }
    }, [crsManagersRes])

    useEffect(() => {
        if (pageNum && !isLoading) {
          setIsLoading(true)
          setIsLoading(true)
          fetchCrsTableReport()
        }
      }, [pageNum,pageSize, progressSort, searchInput])

    return (
        <>
            <Loader start={isLoading} />
            <section className="reports-header pt-5 pb-2">
                <div className="container reports-head-main-filter">
                    <div className="row">
                        <div className="col-md-12">
                            <button
                                type="button"
                                id="backbtnreport"
                                className="btn btn-primary-complete bckbtn mb-3"
                                onClick={() => {
                                    navigate(-1)
                                }}
                            >
                                Back
                            </button>
                            <div className="reports-head-main">
                                Reports
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="agent-user-detailbox">

                                <div className="agent-detsils">
                                    <div class="agent-name-rsp">
                                        {officeDetail?.office_name}
                                    </div>
                                    <div className="agent-desg">
                                        {officeDetail.office_province}, {officeDetail.office_country}
                                    </div>

                                    <div className="applied-filter-agents">
                                        {totalRea?.total_rea} Agent(s), {totalManagers?.total_manager}  Manager(s)
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-page-title"><strong>{isCompliance === "0" ? "Learning Progress" : "Compliance"}</strong></div>
                </div>
            </section>

            {false && <section className="onboarding-report">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 selctdrop-report">
                            <div className="progess-report-title">Compliance Report</div>
                        </div>
                    </div>
                </div>
            </section>}



            <ReportGraphComponent
                trendYear={trendYear}
                loadChart={loaderChart}
                seriesAll={seriesOfAll}
                legendsAll={legendOfAll}
                trendValues={crsCompltTrendValues}
                listingData={courseList}
                seriesSingle={seriesOfSingle}
                legendsSingle={legendOfSingle}
                trendLoadChart={trendLoaderChart}
                filterYearData={filterYearData}
                trendFilterCourses={trendFilterCourses}
                overAllLearningPoints={overAllLearningPoints}
                trendValueSingle={crsCompltTrendValuesOfSingle}
                setYear={setTrendYear}
                setLoadChart={setLoaderChart}
                setImgLoader={setImgLoader}
                getCompletionTrend={getSingleCompletionTrend}
                filterYearDataOfSingle={filterYearDataOfSingle}
                isDetail={true}
                check={check}
                ExportToExcel={ExportToExcel}
                courseOrVideo={JSON.parse(isVideos)}

            />

            <ManagerReportCrs currentReportObj={"compliance"}
                mesg={"The Managers that are assigned for Courses will be shown on this section."}
                isMobile={isMobile}
                check={check}

                isDetail={true}
                totalManagers={totalManagers}
                setTotalManagers={setTotalManagers}

                overAllManagersData={overAllManagersData}
                setOverAllManagersData={setOverAllManagersData}
                setCountForManager={setCountForManager}
                setCounterForMng={setCounterForMng}
                counterForMng={counterForMng}
                cmpletionText={JSON.parse(isVideos) ? "Videos Completed" : "Courses Completed"}
                isLP={false}
                courseOrVideo={JSON.parse(isVideos)}
            />

            <REACardAreaSection
                totalREA={totalRea?.total_rea}
                extraHeader={'- Cumulative Progress of an Agent'}
                realEstateAgent={realEstateAgent}
                isMobile={isMobile}
                actualCoursesList={actualCoursesList}
                setLoadSpin={setLoadSpin}
                loadSpin={loadSpin}
                setCount={setCount}
                counter={counter}
                setCounter={setCounter}
                check={check}
                cmpletionText={JSON.parse(isVideos) ? "Videos Completed" : "Courses Completed"}
                isDetail={true}
                isLP={false}
                courseOrVideo={JSON.parse(isVideos)}
            />

            {false && <section className="progress-box-report">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 flex-titlereport d-flex justify-content-between align-items-baseline">
                            <div className="progess-count-tiel">
                                Real Estate Agents&nbsp;
                                <strong>({totalRea?.total_rea
                                })</strong> - Cumulative Progress of an Agent
                            </div>
                            {/* <div className="input-text fliterreportsgen">
                <label htmlFor="filter" className="input__label">
                  Sort By
                </label>
                <select
                  type="text"
                  id="filter"
                  name="filter"
                  className="form-select input_searchfield mb-0 session-filter"
                  value={filterBy}
                  onChange={onClickFilterBy}
                >
                  {FILTER_BY.map((item, index) => {
                    return (
                      <option seleted key={index}>
                        {item.value}
                      </option>
                    );
                  })}
                </select>
              </div> */}
                        </div>
                    </div>
                    <div className="row mt-3">
                        {(!_.isEmpty(realEstateAgent)) ? realEstateAgent?.map((m, index) => {
                            return (
                                <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-report" key={index}>
                                    <div className="reopor-box-progess">
                                        <div className="progess-profile d-flex">
                                            <div className="user-progess-img">
                                                <img src={m?.profile_pic} width="48" height="48" />
                                            </div>
                                            <div className={`userprogress-details ${(m?.is_allow === true) ? "cursor-pointer" : "cursor-not-allowed"}`}>
                                                <h5
                                                    className="user-tiele"
                                                    onClick={() => {
                                                        if (m?.is_allow === true) {
                                                            navigate(`/profile/edit?section=edit&user_id=${m?.uid}&isOther=1`);
                                                        }
                                                    }}
                                                >
                                                    {m?.user_name}
                                                </h5>
                                                <OverlayTrigger
                                                    key='bottom'
                                                    placement='bottom'
                                                    overlay={
                                                        <Tooltip id={`tooltip-bottom`}>
                                                            <div
                                                                style={{
                                                                    color: "white",
                                                                    backgroundColor: "black",
                                                                }}

                                                            >{m?.office_name}</div>
                                                        </Tooltip>
                                                    }
                                                >
                                                    <p >{m?.office_name}</p>
                                                </OverlayTrigger>
                                                {/* <p>{m?.office_name}</p> */}
                                            </div>
                                        </div>
                                        <hr />
                                        <div class="progress-details">
                                            <div class="progess-report-graph">
                                                <div class="circlebox">
                                                    <div
                                                        className="circularProgress-sm"
                                                        style={{
                                                            width: 72,
                                                            height: 72,
                                                            position: "relative",
                                                        }}
                                                    >
                                                        <CircularProgressbar
                                                            value={m?.learning_percentage}
                                                            strokeWidth={8}
                                                            styles={buildStyles({
                                                                pathColor: "#6941C6", //FF9700=yellow
                                                                trailColor: "#EBEBEB",
                                                            })
                                                            }
                                                        />
                                                        <div className="centerprogess-con"
                                                            style={{
                                                                position: "absolute",
                                                                top: "1.2rem",
                                                                width: "72px",
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            {true ? (
                                                                <>
                                                                    <strong
                                                                        style={{ color: "#6941C6" }}
                                                                    >{`${m?.learning_percentage}%`}</strong>
                                                                    <small>Progress</small>
                                                                </>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="progess-count-show-new">
                                                <div class="learning-points-new">
                                                    <strong>{m?.total_completed}/</strong>{m?.total_assigned}
                                                </div>
                                                <div class="learning-points-name">
                                                    Agents Compliant
                                                </div>
                                            </div>

                                        </div>
                                        <div className="prog-link" onClick={() => {
                                            let url = isMobile ? '/compliance-report-agent-detail-mobile' : '/compliance-report-agent-detail';
                                            url = url + '?id=' + m.uid + "&isCompliance=" + (check ? 1 : 0) + "&isAgent=true";
                                            if(JSON.parse(isVideos))
                                            {
                                              url = url + "&isVideos=true";
                                            } 
                                            else
                                            {
                                              url = url + "&isVideos=false";
                                            }
                                            navigate(url)
                                        }} >
                                            View More
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                            :
                            <div className="col-md-12">
                                <div className="not-found mt-3">
                                    <div className="interboxes">
                                        {/* <img src="/images/telescope.svg" alt="Not Found" /> */}
                                        <NotFoundImage />
                                        <p>The REA's that are assigned for Courses will be shown on this section.</p>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="col-md-12 mt-3">
                            <p className="text-center">
                                {actualCoursesList?.length === 0 || totalRea?.total_rea === realEstateAgent?.length ? "" :
                                    <button
                                        type="button"
                                        id="number"
                                        className="btn btn-primary-complete"
                                        onClick={() => {
                                            setCount(counter, setCounter);
                                            setLoadSpin(true);
                                        }
                                        }
                                    >
                                        {(loadSpin) ?
                                            <div className="d-flex justify-content-center w-100">
                                                <Spinner animation="border" />
                                            </div>
                                            : "Load More"}
                                    </button>
                                }
                                {/* {(_.isEmpty(limitStatus)) ?
                  "" :
                  <button
                    type="button"
                    id="number"
                    className="btn btn-primary-complete"
                    onClick={() => {
                      setCount(counter, setCounter);
                      setLoadSpin(true);
                    }
                    }
                  >
                    {(loadSpin) ?
                      <div className="d-flex justify-content-center w-100">
                        <Spinner animation="border" />
                      </div>
                      : "Load More"}
                  </button>
                } */}
                            </p>
                        </div>
                    </div>
                </div>
            </section>}

            {/* <div id="myOnboard" class="center_line"></div> */}
            <ProgressReportTableComponent
                getFilteredData={[]}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                isView={isView}
                statusFilterData={statusFilterData}
                setCanShow={setCanShow}
                profileReports={profileReports}
                currentTableData={currentTableData}
                type={type}
                message={"Courses/Videos that are assigned to users, will appear here."}
                isCompliance={true}
                searchTable={searchTable}
                fromPage={JSON.parse(isVideos) ? 4: 1}  // 1=course, 2= Learning Path, 3=Onboarding 4=video
                reportType={'compliance'}
                isMobile={isMobile}
                setPageNum={setPageNum}
                pageNum={pageNum}
                pageSize={pageSize}
                setPageSize={setPageSize}
                progressSort={progressSort}
                setProgressSort={setProgressSort}
                searchInput={searchInput}
                setSearchInput={setSearchInput}
                fetchData={fetchCrsTableReport}
            />
        </>
    );
};
export default ComplianceReportSectionDetail;
